export default "__VITE_ASSET__yl$V3H5D__"